import { style } from "@vanilla-extract/css";

import { vars } from "~/styles/tokens.css";

// Circular initials badge. Size and background come from props (as
// inline styles) so callers can fine-tune. Everything else — typography,
// centering, color — is token-driven here.
export const avatar = style({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",

  borderRadius: vars.radius.full,
  flexShrink: 0,

  fontFamily: vars.font.body,
  fontWeight: vars.fontWeight.bold,
  color: vars.color.textInverse,
  letterSpacing: "0.02em",

  userSelect: "none",
});
